import { render, staticRenderFns } from "./AllInfoAboutQualificationPanel.vue?vue&type=template&id=3c3483d0&"
import script from "./AllInfoAboutQualificationPanel.vue?vue&type=script&lang=js&"
export * from "./AllInfoAboutQualificationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports